
export const Theme = ({...props}) => {
    return (
        <div className={"c-theme__container " + (props.url?.url ? "scale-on-hover" : "")} data-aos="fade-up">
            <a 
                href={props.url?.url}
                target={props.url?.target}
                className="c-theme">
                <div className="c-theme-icon__container">
                    <img 
                        alt={props.alt}
                        className="c-theme-icon"
                        src={props.image}
                    />
                </div>  
                <h5 className="c-theme-title">{props.title}</h5>
            </a>
        </div>
    )
}